import type { Candle } from '../../domain/types'
import { generateCandles } from '../synthetic'
import type { StockDataAdapter } from './types'

const UNIVERSE: Array<{ symbol: string; name: string; startPrice: number; drift: number; vol: number }> = [
  { symbol: 'NOVA', name: 'Nova Compute Inc.', startPrice: 142, drift: 0.18, vol: 0.42 },
  { symbol: 'ATLS', name: 'Atlas Logistics', startPrice: 88, drift: 0.06, vol: 0.28 },
  { symbol: 'HELX', name: 'Helix Biotech', startPrice: 54, drift: 0.12, vol: 0.55 },
  { symbol: 'ORCA', name: 'Orca Energy', startPrice: 31, drift: -0.04, vol: 0.36 },
  { symbol: 'VOLT', name: 'Voltaic Motors', startPrice: 210, drift: 0.22, vol: 0.6 },
  { symbol: 'CIRR', name: 'Cirrus Cloud', startPrice: 99, drift: 0.1, vol: 0.33 },
]

export function createMockStockAdapter(): StockDataAdapter {
  return {
    id: 'mock-stock',
    name: 'Mock Stock Feed (synthetic)',
    requiresApiKey: false,
    description: 'Deterministic synthetic OHLCV generated locally. No network, no API key, safe for demos.',
    async fetchCandles(symbol: string, days = 260): Promise<Candle[]> {
      const meta = UNIVERSE.find((u) => u.symbol === symbol.toUpperCase())
      return generateCandles({
        symbol: symbol.toUpperCase(),
        startPrice: meta?.startPrice ?? 100,
        annualDrift: meta?.drift ?? 0.08,
        annualVol: meta?.vol ?? 0.35,
        days,
      })
    },
    async search(query: string) {
      const q = query.trim().toUpperCase()
      return UNIVERSE.filter((u) => u.symbol.includes(q) || u.name.toUpperCase().includes(q)).map((u) => ({
        symbol: u.symbol,
        name: u.name,
      }))
    },
  }
}

export const STOCK_UNIVERSE = UNIVERSE
